import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import authApi from '../../api/auth';
import {
  ARROWDOWN_ICON,
  FEEDBACK_ICON,
  LOGOUT_ICON,
  PERSON_ICON,
  RECEIPT_ICON,
  SETTINGS_ICON
} from '../../assets/icons';
import { useAppDispatch } from '../../hooks/useRedux';
import { login } from '../../reducers/authSlice';
import { setUserProfile } from '../../reducers/profileSlice';
export default function Account() {
  const menuOptions = [
    {
      title: 'Profile',
      icon: PERSON_ICON,
      path: '/account',
      subMenus: [
        {
          title: 'Personal Info',
          path: '/account/personal'
        },
        {
          title: 'Education Details',
          path: '/account/education'
        },
        {
          title: 'Experience Details',
          path: '/account/experience'
        },
        {
          title: 'Subjects I teach',
          path: '/account/subjects'
        }
      ]
    },
    {
      title: 'Transactions and Receipts',
      path: '/account/transactions',
      icon: RECEIPT_ICON
    },
    {
      title: 'Settings',
      path: '/account/settings',
      icon: SETTINGS_ICON
    },
    {
      title: 'Share feedback',
      path: '/account/feedback',
      icon: FEEDBACK_ICON
    }
  ];
  const dispatch = useAppDispatch();
  const [active, setActive] = useState(0);
  const location = useLocation();

  const logout = async () => {
    await authApi.logout().catch((/* err */) => {
      /* console.log(err) */
    });
    dispatch(login(null));
    dispatch(setUserProfile(null));
  };

  return (
    <div className="w-full max-h-screen flex flex-col">
      <div className="w-full flex lg:flex-row flex-col grow overflow-y-scroll no-scrollbar">
        <div className="lg:w-3/12 lg:top-0 lg:h-screen lg:bg-neutralBlue2 lg:flex lg:flex-col lg:gap-7 lg:px-10 lg:pt-16 lg:pb-24 hidden">
          {menuOptions.map((item, index) => (
            <Menu item={item} key={index} />
          ))}

          <div onClick={() => logout()} className="mt-auto flex items-center gap-4 cursor-pointer">
            <img src={LOGOUT_ICON} className="w-4" />
            <p className="text-secondary text-sm font-medium">Logout</p>
          </div>
        </div>
        {(location.pathname === '/account' ||
          location.pathname === '/account/personal' ||
          location.pathname === '/account/education' ||
          location.pathname === '/account/experience' ||
          location.pathname === '/account/subjects') && (
            <div className="flex md:hidden flex-col gap-7 p-4">
              <h1 className="text-2xl font-semibold">Edit Details</h1>
              <div className="flex flex-row w-full justify-between border-b border-black overflow-x-scroll no-scrollbar whitespace-nowrap lg:hidden">
                <Link
                  to="/account/personal"
                  className={`px-4 py-2 text-sm font-medium ${active === 0 ? ' border-b-[3px] border-secondary' : ''}`}
                  onClick={() => setActive(0)}
                >
                  Personal Details
                </Link>
                <Link
                  to="/account/education"
                  className={`px-4 py-2 text-sm font-medium ${active === 1 ? ' border-b-[3px] border-secondary' : ''}`}
                  onClick={() => setActive(1)}
                >
                  Education Details
                </Link>
                <Link
                  to="/account/experience"
                  className={`px-4 py-2 text-sm font-medium ${active === 2 ? ' border-b-[3px] border-secondary' : ''}`}
                  onClick={() => setActive(2)}
                >
                  Experience Details
                </Link>
                <Link
                  to="/account/subjects"
                  className={`px-4 py-2 text-sm font-medium ${active === 3 ? ' border-b-[3px] border-secondary' : ''}`}
                  onClick={() => setActive(3)}
                >
                  Profession Details
                </Link>
              </div>
            </div>
          )}
        <div className="w-full lg:px-7 px-4 overflow-y-scroll no-scrollbar">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function Menu({
  item
}: {
  item: {
    title: string;
    path: string;
    icon: string;
    subMenus?: {
      title: string;
      path: string;
    }[];
  };
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full flex flex-col gap-4">
      <Link to={item.path}>
        <div onClick={() => setOpen(!open)} className="w-full flex gap-2 items-center cursor-pointer">
          <img src={item.icon} className="w-3" />
          <h1 className="text-sm text-primary font-medium">{item.title}</h1>
          {item.subMenus && (
            <img src={ARROWDOWN_ICON} className={`w-3 ml-auto ${open ? 'rotate-180' : 'rotate-0'} transition-all`} />
          )}
        </div>
      </Link>

      {item.subMenus && open && (
        <div className="w-full flex flex-col gap-4 ml-4 border-l border-neutralGray3 px-4">
          {item.subMenus.map((subMenu, index) => (
            <Link to={subMenu.path} key={index}>
              <p className="text-sm text-neutralGray1 cursor-pointer">{subMenu.title}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
